export const Gallery = '/gallery';
export const Reviews = '/reviews';
export const FAQ = '/faq';
export const Email = '/email';
export const PoweredBy = '/poweredby';
// export const Photoshoot = '/photoshoot';
export const Services = '/services';
